<forge-card class="no-padding">
    <form fxLayout="column" [formGroup]="bidQuoteForm">

        @if (!canEdit) {
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <labeled-field fxFlex="60" label="Vendor">
                <span>{{VendorName}}</span>
            </labeled-field>
            <labeled-field fxFlex="30" label="Total Bid/Quote">
                <span> {{TotalQuote | currency}} </span>
            </labeled-field>
        </div>
        }

        @if (canEdit) {
        <div fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-typeahead fxFlex="50" controlName="vendor" label="Bidding Vendor"
                (searchTextChanged)="lookupVendors($event)" [options]="vendorObservable"
                telemetry="Edit-BiddingVendor-BidQuote-Purchasing">
            </lgd-typeahead>
            <lgd-currency controlName="total" label="Total Bid/Quote" telemetry="Edit-TotalBid-BidQuote-Purchasing">
            </lgd-currency>
            <command [command]="deleteCmd"></command>
        </div>
        }

        <div fxFlex="auto" fxLayout="row" fxLayoutAlign="space-between start">
            <lgd-checkbox controlName="awarded" label="Awarded">
            </lgd-checkbox>

            <lgd-date-picker controlName="awardedDate" label="Awarded Date">
            </lgd-date-picker>

            <forge-chip-set type="choice">
                <forge-chip (click)="showNotes()">Notes ({{Notes}})</forge-chip>
                <forge-chip (click)="showAttachments()">Attachments ({{Attachments}})</forge-chip>
            </forge-chip-set>
        </div>
    </form>
</forge-card>